import { Moment } from "moment-timezone";
import React, { ChangeEvent, Component } from "react";
import PropTypes from "prop-types";
import IGetCommissionTiersDTO from "../../../../models/DTO/IGetCommissionTiersDTO";
import IGetRebateGroupDTO from "../../../../models/DTO/IGetRebateGroupDTO";
import IOnGetCommissionTiersDTO from "../../../../models/DTO/IOnGetCommissionTiersDTO";
import IOnGetRebateGroupDTO from "../../../../models/DTO/IOnGetRebateGroupDTO";
import IOnUpdateCommissionTiersDTO from "../../../../models/DTO/IOnUpdateCommissionTiersDTO";
import IOnUpdateRebateGroupDTO from "../../../../models/DTO/IOnUpdateRebateGroupDTO";
import IOnUpdateSpiffGroupDTO from "../../../../models/DTO/IOnUpdateSpiffGroupDTO";
import IUpdateCommissionTiersDTO from "../../../../models/DTO/IUpdateCommissionTiersDTO";
import IUpdateRebateGroupDTO from "../../../../models/DTO/IUpdateRebateGroupDTO";
import IUpdateSpiffGroupDTO from "../../../../models/DTO/IUpdateSpiffGroupDTO";
import ICommission_Tiers from "../../../../models/ICommission_Tiers";
import IRebate from "../../../../models/IRebate";
import IRebate_Group from "../../../../models/IRebate_Group";
import ISpiff_Group from "../../../../models/ISpiff_Group";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import IVendorModel from "../../../../models/IVendorModel";
import { LoadingResults } from "../../../shared/LoadingResults/LoadingResults";
import NoResults from "../../../shared/NoResults/NoResults";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwDateRange from "../../../shared/OwDateRange/OwDateRange";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import moment from "moment";
import { Socket } from "socket.io-client";

type Props = {
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    spiffGroup?: ISpiff_Group;
};

type State = {
    spiffGroup: ISpiff_Group;
    disableSave: boolean;
    activeSave: boolean;
    resultsLoaded: boolean;
};

class SpiffGroupSidebar extends Component<Props, State> {
    readonly state: State = {
        spiffGroup: this.props.spiffGroup || ({ name: "" } as ISpiff_Group),
        disableSave: false,
        activeSave: false,
        resultsLoaded: false,
    };

    componentDidMount(): void {
        this.props.socket.on("onCreateSpiffGroup", this.onCreateSpiffGroup);
        this.props.socket.on("onUpdateSpiffGroup", this.onUpdateSpiffGroup);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener("onCreateSpiffGroup", this.onCreateSpiffGroup);
        this.props.socket.removeListener("onUpdateSpiffGroup", this.onUpdateSpiffGroup);
    }

    onCreateSpiffGroup = (data: IOnUpdateSpiffGroupDTO) => {
        // refresh the commission tiers.
        this.cancel();
    };

    onUpdateSpiffGroup = (data: IOnUpdateSpiffGroupDTO) => {
        // refresh the commission tiers.
        this.cancel();
    };

    cancel = () => {
        this.props.toggleSidebar(false);
    };

    saveSpiffGroup = () => {
        const payload: IUpdateSpiffGroupDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            spiffGroup: this.state.spiffGroup,
        };

        if (payload.spiffGroup.id) {
            this.props.socket.emit("updateSpiffGroup", payload);
        } else {
            this.props.socket.emit("createSpiffGroup", payload);
        }
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const spiffGroup = this.state.spiffGroup;

        // @ts-expect-error
        spiffGroup[name] = value;

        this.setState({
            spiffGroup,
        });
    };

    handleStartDate = (startDate: Moment | null) => {
        const spiffGroup = this.state.spiffGroup;

        if (startDate) {
            spiffGroup.min_date = startDate.format("YYYY-MM-DD 00:00:00");
        }

        this.setState({
            spiffGroup,
        });
    };

    handleEndDate = (endDate: Moment | null) => {
        const spiffGroup = this.state.spiffGroup;

        if (endDate) {
            spiffGroup.max_date = endDate.format("YYYY-MM-DD 23:59:59");
        }

        this.setState({
            spiffGroup,
        });
    };

    render() {
        let startDateSelected;
        let endDateSelected;

        if (this.state.spiffGroup.min_date) {
            startDateSelected = moment(this.state.spiffGroup.min_date).toDate();
        }

        if (this.state.spiffGroup.max_date) {
            endDateSelected = moment(this.state.spiffGroup.max_date).toDate();
        }

        let saveDisabled = true;

        if (startDateSelected && endDateSelected && this.state.spiffGroup.name) {
            saveDisabled = false;
        }

        return (
            <div className="SpiffGroupSidebar p-3" style={{ height: "100vh", overflow: "hidden" }}>
                <div style={{ height: "15vh" }}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle leftIconName={"fad fa-funnel-dollar"} title={"SPIFF"} />
                    <hr />
                </div>
                <div className="SpiffGroupForm pb-2" style={{ height: "85vh", overflowY: "scroll" }}>
                    {/*<div>*/}
                    {/*    <OwCheckbox*/}
                    {/*        label={"is_global_spiff"}*/}
                    {/*        fn={this.handleSupplierChange}*/}
                    {/*        name={"is_global_spiff"}*/}
                    {/*        checked={this.state.spiffGroup.is_global_spiff}*/}
                    {/*    />*/}
                    {/*</div>*/}

                    <div className={"mt-2"}>
                        <OwLabel title={"spiff_group_name"} />
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.spiffGroup.name} />
                    </div>

                    <div>
                        <OwLabel title={"active_period"} className={"mt-2"} />
                        <OwDateRange
                            startFn={this.handleStartDate}
                            endFn={this.handleEndDate}
                            startDateSelected={startDateSelected}
                            endDateSelected={endDateSelected}
                        />
                    </div>

                    <div className={"mt-2"}>
                        <OwButton
                            disabled={saveDisabled}
                            active={this.state.activeSave}
                            leftIconClass=""
                            className="btn-primary me-2"
                            title="save"
                            fn={this.saveSpiffGroup}
                        />

                        <OwButton className={"btn-danger"} fn={this.cancel} title={"cancel"} />
                    </div>
                </div>
            </div>
        );
    }
}

export default SpiffGroupSidebar;
